import type { ContactFormSchema } from "./validation";

import createFetcher from "libs/fetcher/client";

const handler = createFetcher<ContactFormSchema, {}>("/api/contact/", "POST");

export default handler;
